export const TIPO_FORMAS_PAGAMENTO = [
  { label: "DINHEIRO", value: "DINHEIRO" },
  { label: "CARTÃO", value: "CARTAO" },
  { label: "PICPAY", value: "PICPAY" },
  { label: "PIX", value: "PIX" },
  { label: "OUTROS", value: "OUTROS" },
];

export const TIPO_FORMAS_PAGAMENTO_ONLINE = [
  { label: "CARTÃO DE CRÉDITO", value: "CREDIT_CARD" },
  { label: "PIX", value: "PIX" },
];

export const TIPO_FORMAS_PIX = [
  { label: "CPF", value: "CPF" },
  { label: "CNPJ", value: "CNPJ" },
  { label: "EMAIL", value: "EMAIL" },
  { label: "TELEFONE", value: "TELEFONE" },
  { label: "OUTROS", value: "OUTROS" },
];
